export const NUMBER_COLOR = {
    1: "yellowgreen",
    2: "#ff7675",
    3: "#6c5ce7",
    4: "#2d3436",
    5: "#22a6b3",
  };
